export default __webpack_public_path__ + "static/media/icon-ipd.56f8c0ae.svg";